import styled from 'styled-components';
import { themes } from 'kb-shared';
const { colors, fonts } = themes;

export default styled.button`
  ${fonts.FoundersGrotesk};
  font-weight: bold;
  background-color: ${colors.beigeLight};
  border-radius: 24px;
  color: ${colors.KBNight};
  cursor: pointer;
  font-size: 18px;
  padding: 10px 15px 10px 0px;
  @media screen and (max-width: ${themes.breakpoints.largePhonePortrait}) {
    padding: 10px 15px 10px 12px;
  }
`;
